import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionRepresentanteEditarComponent {
  clienteId
  representanteId
  onChange
  onClose
  catalogo = {
    representanteTipo: [],
  }
  error = null
  procesando = false
  data = {}

  constructor ($q, CatalogoRepresentanteTipo, ClienteInformacionRepresentante) {
    this.$q = $q
    this.CatalogoRepresentanteTipo = CatalogoRepresentanteTipo
    this.ClienteInformacionRepresentante = ClienteInformacionRepresentante
  }

  $onInit () {
    this.promise = this.$q.all([
      this.ClienteInformacionRepresentante.get(this.clienteId, this.representanteId)
        .then(({data}) => (this.data = data)),
      this.CatalogoRepresentanteTipo.get()
        .then(({data}) => (this.catalogo.representanteTipo = data)),
    ])
  }

  actualizar () {
    if (this.procesando) return

    this.error = null
    this.procesando = true

    this.ClienteInformacionRepresentante.put(this.clienteId, this.representanteId, this.data)
      .then(({data}) => (this.onChange({$event: {detail: data}})))
      .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.onClose()
  }
}

module.component('clienteInformacionRepresentanteEditar', {
  controller: ClienteInformacionRepresentanteEditarComponent,
  template,
  bindings: {
    clienteId: '<',
    representanteId: '<',
    onChange: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/representante/editar/component.js